import { AxiosResponse } from 'axios';
import { API } from 'config';
import { LIST_BODY_RESULT } from 'models';
import {
  CREATE_PUBLIC_HOLIDAY_PAYLOAD,
  PUBLIC_HOLIDAY_ITEM_TYPE,
  PUBLIC_HOLIDAY_LIST_PARAMS_REQUEST,
  UPDATE_PUBLIC_HOLIDAY_PAYLOAD,
} from 'models/public-holiday';
import { AppAPIInstance } from 'services/config-api';

export const getPublicHolidayListApi = async (
  params?: PUBLIC_HOLIDAY_LIST_PARAMS_REQUEST
): Promise<
  AxiosResponse<{ data: LIST_BODY_RESULT<PUBLIC_HOLIDAY_ITEM_TYPE> }>
> => {
  return await AppAPIInstance.get(API.CONCIERGE.PUBLIC_HOLIDAY.LIST, {
    params,
  });
};

export const createPublicHolidayApi = async (
  data: CREATE_PUBLIC_HOLIDAY_PAYLOAD
) => {
  return await AppAPIInstance.post(API.CONCIERGE.PUBLIC_HOLIDAY.CREATE, data);
};

export const updatePublicHolidayApi = async (
  id: string,
  data: UPDATE_PUBLIC_HOLIDAY_PAYLOAD
) => {
  return await AppAPIInstance.put(
    API.CONCIERGE.PUBLIC_HOLIDAY.UPDATE(id),
    data
  );
};

export const deletePublicHolidayApi = async (id: string) => {
  return await AppAPIInstance.delete(API.CONCIERGE.PUBLIC_HOLIDAY.DELETE(id));
};

export const getDetailPublicHolidayApi = async (id: string) => {
  return await AppAPIInstance.get(API.CONCIERGE.PUBLIC_HOLIDAY.DETAIL(id));
};
